// extracted by mini-css-extract-plugin
export default {"chat-offcanvas":"TicketView_chat-offcanvas__PDa+p"};